/**
 * Apposé — DPO option to product image swap.
 *
 * When a customer clicks a wristband (or any DPO option), swap the main
 * product image to the matching combination photo from product media.
 *
 * Two-layer lookup:
 *   1. Apposé brand name → image keyword (e.g. "Jetsetter Noir" → "black")
 *   2. Fallback: literal color word (e.g. "merlot")
 *
 * Searches the swatch's alt, title, data-*, aria-label, label text, and
 * its image filename. Then finds an image in the product gallery whose
 * src contains the keyword. Swaps silently if no match.
 */
(function () {
  'use strict';

  var DPO_SELECTOR = '#dpo_placeholder';
  var MAIN_GALLERY_SELECTOR = '.product__media-list';
  var ATTEMPTED = false;

  // Apposé brand names → image filename keyword. Order matters: multi-word
  // brand names first so they match before generic words.
  var BRAND_ALIASES = [
    { name: 'jetsetter noir',     keyword: 'black' },
    { name: 'jetsetter-noir',     keyword: 'black' },
    { name: 'mancini cream',      keyword: 'cream' },
    { name: 'mancini-cream',      keyword: 'cream' },
    { name: 'merlot reserve',     keyword: 'merlot' },
    { name: 'merlot-reserve',     keyword: 'merlot' },
    { name: 'tuscan camel',       keyword: 'camel' },
    { name: 'tuscan-camel',       keyword: 'camel' },
    { name: 'parisian midnight',  keyword: 'navy' },
    { name: 'parisian-midnight',  keyword: 'navy' },
    { name: 'aspen blanc',        keyword: 'white' },
    { name: 'aspen-blanc',        keyword: 'white' }
  ];

  // Literal color tokens (fallback). Multi-word first.
  var LITERAL_COLORS = [
    'aspen-blanc', 'aspen blanc',
    'aspen-white', 'aspen white',
    'midnight', 'merlot', 'camel', 'cream', 'navy', 'noir',
    'black', 'white', 'blanc'
  ];

  // Mapping from literal color → image filename keyword (for cases where the
  // option text already uses a literal but the filename uses a synonym).
  var LITERAL_TO_KEYWORD = {
    'noir': 'black',
    'midnight': 'navy',
    'blanc': 'white',
    'aspen-blanc': 'white',
    'aspen blanc': 'white',
    'aspen-white': 'white',
    'aspen white': 'white'
  };

  function normalize(str) {
    return (str || '').toString().toLowerCase().replace(/[_]+/g, '-').replace(/\s+/g, ' ').trim();
  }

  function detectKeyword(text) {
    var n = normalize(text);
    if (!n) return null;

    // 1. Try brand alias
    for (var i = 0; i < BRAND_ALIASES.length; i++) {
      if (n.indexOf(BRAND_ALIASES[i].name) !== -1) return BRAND_ALIASES[i].keyword;
    }

    // 2. Try literal color (with synonym remap)
    for (var j = 0; j < LITERAL_COLORS.length; j++) {
      if (n.indexOf(LITERAL_COLORS[j]) !== -1) {
        var token = LITERAL_COLORS[j];
        return LITERAL_TO_KEYWORD[token] || token;
      }
    }
    return null;
  }

  function findKeywordFromElement(el) {
    if (!el) return null;
    var node = el;
    for (var depth = 0; depth < 5 && node; depth++) {
      var candidates = [
        node.getAttribute && node.getAttribute('alt'),
        node.getAttribute && node.getAttribute('title'),
        node.getAttribute && node.getAttribute('aria-label'),
        node.getAttribute && node.getAttribute('data-value'),
        node.getAttribute && node.getAttribute('data-option-value'),
        node.getAttribute && node.getAttribute('data-name'),
        node.textContent
      ];
      if (node.querySelector) {
        var innerImg = node.querySelector('img');
        if (innerImg) {
          candidates.push(innerImg.getAttribute('alt'));
          candidates.push(innerImg.getAttribute('title'));
          candidates.push(innerImg.src);
        }
      }
      for (var i = 0; i < candidates.length; i++) {
        var keyword = detectKeyword(candidates[i]);
        if (keyword) return keyword;
      }
      node = node.parentElement;
    }
    return null;
  }

  function findGalleryImageForKeyword(keyword) {
    if (!keyword) return null;
    var images = document.querySelectorAll(MAIN_GALLERY_SELECTOR + ' .product__media-item img');
    var k = normalize(keyword);
    for (var i = 0; i < images.length; i++) {
      var src = normalize(images[i].src || '');
      if (src.indexOf(k) !== -1) return images[i];
    }
    for (var j = 0; j < images.length; j++) {
      var srcset = normalize(images[j].getAttribute('srcset') || '');
      if (srcset.indexOf(k) !== -1) return images[j];
    }
    return null;
  }

  function swapMainImageTo(targetImg) {
    if (!targetImg) return;
    var gallery = document.querySelector(MAIN_GALLERY_SELECTOR);
    if (!gallery) return;
    var activeItem = gallery.querySelector('.product__media-item.is-active') || gallery.querySelector('.product__media-item');
    if (!activeItem) return;
    var mainImg = activeItem.querySelector('img');
    if (!mainImg) return;
    mainImg.src = targetImg.src;
    var srcset = targetImg.getAttribute('srcset');
    if (srcset) {
      mainImg.setAttribute('srcset', srcset);
    } else {
      mainImg.removeAttribute('srcset');
    }
  }

  function handleDpoClick(e) {
    var keyword = findKeywordFromElement(e.target);
    if (!keyword) return;
    var galleryImg = findGalleryImageForKeyword(keyword);
    if (galleryImg) swapMainImageTo(galleryImg);
  }

  function init() {
    var dpo = document.querySelector(DPO_SELECTOR);
    if (!dpo || ATTEMPTED) return;
    ATTEMPTED = true;
    dpo.addEventListener('click', handleDpoClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(function () { ATTEMPTED = false; init(); }, 1500);
  setTimeout(function () { ATTEMPTED = false; init(); }, 4000);
})();
